import {twMerge} from '../../../common/twMerge';
import {Dot} from '../../atoms/Dot/Dot';
import {Icon} from '../../atoms/Icon/Icon';
import {Text} from '../../atoms/Text/Text';
import {DirectionType} from './IconTextBox.enum';
import {IconTextBoxProps} from './IconTextBoxProps.interface';

export function IconTextBox({
  iconType,
  label,
  direction = DirectionType.Column,
  hasDot,
  textStyle,
  textClassName,
  className,
  ...props
}: IconTextBoxProps) {
  return (
    <div
      className={twMerge(
        directionTypeToStyles[direction],
        'relative flex h-full items-center justify-center',
        className
      )}
      {...props}
    >
      <div className="relative">
        <Icon type={iconType} alt="아이콘" disableActiveEffect />
        {hasDot && direction === DirectionType.Column && (
          <Dot className="absolute -top-2pxr -right-3pxr" />
        )}
      </div>
      <div className="relative">
        <Text
          className={twMerge(
            'font-small2 block text-theme-solid-60',
            textClassName
          )}
          style={textStyle}
        >
          {label}
        </Text>
        {hasDot && direction === DirectionType.Row && (
          <Dot className="absolute top-0 -right-4pxr" />
        )}
      </div>
    </div>
  );
}

const directionTypeToStyles = {
  [DirectionType.Row]: 'flex-row',
  [DirectionType.Column]: 'flex-col',
};
